import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_participate_in_any_of_the_following_activities_rela_2'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_participate_in_any_of_the_following_activities_rela_2',
  name: 'Did the facility participate in any of the following activities related to community investment? (SELECT all that apply with a "X":)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THE_FACILITY_DRAFTED__OR_MAINTAINED_AN_EXISTING__STRATEGY_POLIC',
      text: 'The facility drafted (or maintained an existing) strategy/policy for community investment that includes assessment of root causes of social issues in community related to its workforce',
      externalIds: [
        {
          id: 'ab-9-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-9-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_WORKERS_AND_LOCAL_CIVIL_SOCIETY_GROUPS_WERE_ENGAGED_IN',
      text: 'Facility workers and local civil society groups were engaged in identifying, implementing, and evaluating community investment initiatives',
      externalIds: [
        {
          id: 'ab-9-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-9-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'THE_FACILITY_WAS_INVOLVED_DIRECTLY_OR_THROUGH_PARTNERSHIPS_IN_E',
      text: 'The facility was involved directly or through partnerships in efforts on the ground that address root causes of social issues in the local community',
      externalIds: [
        {
          id: 'ab-9-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-9-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-9-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-9-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-9-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'THE_FACILITY_DRAFTED__OR_MAINTAINED_AN_EXISTING__STRATEGY_POLIC',
                'FACILITY_WORKERS_AND_LOCAL_CIVIL_SOCIETY_GROUPS_WERE_ENGAGED_IN',
                'THE_FACILITY_WAS_INVOLVED_DIRECTLY_OR_THROUGH_PARTNERSHIPS_IN_E',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-16',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24960,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
